import React from 'react'

import { Form } from '_zari/core'

const NumeroDocumentoFormGroup = props => {
  return <Form.InputText {...props} />
}

export default React.memo(NumeroDocumentoFormGroup)
